import React from "react";

import {
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
  Text
} from "@chakra-ui/react";

import { BsInfoCircle } from "react-icons/bs";

interface MoreInfoProps extends PopoverProps {
  title?: string;
  text?: string;
  icon?: any;
  maxWidth?: number;
  textElement?: React.ReactNode;
}

export const MoreInfo: React.FC<MoreInfoProps> = ({
  title,
  text,
  icon = BsInfoCircle,
  placement = "right",
  trigger = "hover",
  maxWidth,
  textElement,
  ...rest
}) => (
  <Popover placement={placement} trigger={trigger} {...rest}>
    <PopoverTrigger>
      <span>
        <Icon fontSize="xs" as={icon} />
      </span>
    </PopoverTrigger>
    <PopoverContent maxWidth={maxWidth} color="black" bg="white">
      <PopoverArrow bg="white" />
      <PopoverBody p={3} fontSize="xs">
        {title && (
          <>
            <b>{title}</b> <br />
          </>
        )}

        {React.isValidElement(textElement) ? (
          textElement
        ) : (
          <Text style={{ whiteSpace: "pre-wrap" }}>{text}</Text>
        )}
      </PopoverBody>
    </PopoverContent>
  </Popover>
);
